import { render } from "./GenesisDrop.vue?vue&type=template&id=15172dd6&scoped=true"
import script from "./GenesisDrop.vue?vue&type=script&lang=js"
export * from "./GenesisDrop.vue?vue&type=script&lang=js"

import "./GenesisDrop.vue?vue&type=style&index=0&id=15172dd6&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-15172dd6"]])

export default __exports__